
import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

/**
 * Switch con `v-model` (evento `change`). Guarda el valor en `localValue` y nunca muta la prop: si el padre se
 * re-renderiza antes de recibir el `change` (p. ej. un campo de texto que pierde el foco al hacer click en el
 * switch), una prop mutada vuelve al valor del padre y el switch se "destilda" solo.
 */
@Component
export default class SwitchToggle extends Vue {
  @Model('change', { type: Boolean, default: false }) readonly isOn!: boolean;

  @Prop({ default: 'Encendido' }) onText!: string;
  @Prop({ default: 'Apagado' }) offText!: string;
  @Prop({ default: false }) dark!: boolean;

  localValue: boolean = false;

  created() {
    this.localValue = this.isOn;
  }

  @Watch('isOn')
  onIsOnChanged(newValue: boolean) {
    this.localValue = newValue;
  }

  onSwitchChange(value: boolean) {
    this.localValue = !!value;
    this.$emit('change', this.localValue);
  }
}
